module.exports = __webpack_public_path__ + "img/dollar-symbol.83a62831.svg";